import type { CreateReason, LoadReasons, ToggleReason, UpdateReason } from '@/domain/use-cases/reasons.js';
import { BaseControllerImpl } from '@/presentation/controllers/base/implementation.js';
import type { ReasonCategory } from '@/shared/utils/format-status.js';

export class ReasonController extends BaseControllerImpl {
    constructor(
        private readonly loadReasonsUseCase: LoadReasons,
        private readonly createReasonUseCase: CreateReason,
        private readonly updateReasonUseCase: UpdateReason,
        private readonly toggleReasonUseCase: ToggleReason
    ) {
        super();
    }

    public async loadReasons(params?: { category?: string; isActive?: boolean }) {
        return this.loadReasonsUseCase.execute(params);
    }

    public async createReason(params: { label: string; category: ReasonCategory; sortOrder?: number }) {
        return this.createReasonUseCase.execute(params);
    }

    public async updateReason(id: string, params: { label: string; category: ReasonCategory; sortOrder?: number }) {
        return this.updateReasonUseCase.execute(id, params);
    }

    public async toggleReason(id: string, active: boolean) {
        return this.toggleReasonUseCase.execute(id, active);
    }
}
